import { ApiVersion } from "./apiRoutes";

// ! uses the REACT_APP_API_URL when it is defined in .env.* files (right now only for .env.production)
// ! as long as the proxy in package.json is set, the url should be empty ...
// ! ... because API calls (for local development ) are send via proxy to prevent the browser from throwing CORS error
// ! if the client and api are on same server and domain no BASE_API_URL is needed
export const API_URL = process.env.REACT_APP_BASE_API_URL || "";
export const CURRENT_API_VERSION =
  process.env.REACT_APP_CURRENT_API_VERSION || ApiVersion.Default;
